/* Hameed Automation: header behaviour, same as main.js on www.hameedautomation.com */
(function () {
  'use strict';

  /* ---------- Header: shadow on scroll ---------- */
  var header = document.querySelector('.ha-header');
  var onScroll = function () { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Mobile menu ---------- */
  var toggle = document.querySelector('.ha-menu-toggle');
  var nav = document.getElementById('ha-nav');
  if (toggle && nav) {
    var setOpen = function (open) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      nav.classList.toggle('is-open', open);
    };
    toggle.addEventListener('click', function () { setOpen(toggle.getAttribute('aria-expanded') !== 'true'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    window.matchMedia('(min-width: 1081px)').addEventListener('change', function (e) { if (e.matches) setOpen(false); });
  }

  /* ---------- Dropdowns: one open at a time, close on outside click / Escape ---------- */
  var menus = document.querySelectorAll('.ha-nav__menu');
  Array.prototype.forEach.call(menus, function (menu) {
    menu.addEventListener('toggle', function () {
      if (!menu.open) return;
      Array.prototype.forEach.call(menus, function (other) { if (other !== menu) other.removeAttribute('open'); });
    });
    document.addEventListener('click', function (e) { if (!menu.contains(e.target)) menu.removeAttribute('open'); });
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
    });
  });
})();
